import React from 'react';
import ReactToPrint from 'react-to-print';
//import dymo from 'assets/DYMO.Label.Framework.latest';
const Dymo = require('dymojs');

const style = `
	@page {
		size: 4in 2.5in portrait;
		padding: 0mm;
		margin: 0mm;
	}
	@media print {
		body {
			-webkit-print-color-adjust: exact;
			margin: 0px  !important;
			padding: 0px !important;
			font-size: 14px;
			font-family: Arial,	sans-serif;
			width:100%;
			;
		}
	}`;

// Wrapper around ReactToPrint that works around its pattern of passing anonymous functions in the render method
class Print extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			contentRef: null,
			triggerElement: () => this.props.trigger,
		}
	}

	getContentRef = (ref) => {
		if (!ref) return;

		this.setState({
			contentRef: () => ref
		})
	}

	render() {
		const {content, trigger, ...rest} = this.props;
		const {contentRef, triggerElement} = this.state;

		if (!contentRef) {
			return (
				<div ref={this.getContentRef}>
					{content}
				</div>
			)
		}

		return (
			<ReactToPrint
				content={contentRef}
				trigger={triggerElement}
				pageStyle={style}
				{...rest}
			/>
		);
	}
}

export class PrintBarcodeModal extends React.Component {
	render() {
		const {onClose, longBarCode, shortBarCode, showFullLabel} = this.props;

		return (
			<div className="react-confirm-alert">
				<div className="react-confirm-alert-body">
					<h1>Product Label Printing</h1>
					<p>
						We support both <b>Address (#30252 - 1 1/8" x 3 1/2")</b> and <b>Shipping (#30256 - 2 5/16" x 4")</b> labels for
						product labeling.<br/>
						<img src="/assets/images/product_label_samples.png" style={{maxWidth: '100%', margin: '10px 0px'}}
						     alt={'Product Label Samples'}/><br/>
						Address or <b>Barcode Only</b> labels just print the <b>Serial Number</b> and <b>Barcode</b>.<br/>
						<br/>
						Shipping or <b>Full Labels</b> print the Barcode, Serial Number, and additional product details.<br/>
						<br/>
						Which would you like to print?
					</p>
					<div className="react-confirm-alert-button-group">
						<div style={{display: 'flex', width: '100%', justifyContent: 'flex-end'}}>
							{showFullLabel && <Print
								trigger={
									<button style={{left: '0px', marginRight: 'auto'}} className={'btn btn-default'}>
										Full Label
									</button>
								}
								content={longBarCode}
								onAfterPrint={onClose}
								copyStyles={false}
							/>}
							<Print
								trigger={
									<button style={{marginRight: '0'}} className={'btn btn-default'}>
										Barcode Only
									</button>
								}
								content={shortBarCode}
								onAfterPrint={onClose}
								copyStyles={false}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
